import type { NotificationItem } from '../../services/api/notifications'

import { getActiveChatSessionId } from './activeChatSessionRegistry'

export function getNotificationToastKey(item: NotificationItem): string {
  if (item.id) return item.id
  const sessionId = item.entity_id || (item.data?.session_id as string | undefined)
  const createdAt = item.created_at ?? ''
  return `${item.category}:${sessionId ?? ''}:${createdAt}`
}

export function shouldSuppressAgentResponseToast(
  pathname: string,
  search: string,
  item: NotificationItem,
): boolean {
  if (item.category !== 'agent_response') return false

  const sessionId = item.entity_id || (item.data?.session_id as string | undefined)
  if (!sessionId) return false

  if (getActiveChatSessionId() === sessionId) return true
  if (pathname.includes(`/sessions/${sessionId}`)) return true

  const sessionParam = new URLSearchParams(search).get('session')
  if (pathname.includes('/agent-studio/chat/') && sessionParam === sessionId) return true
  // wiz-ignore: WS-I002-JAVASCRIPT-00082 — linear client-only path check, not user-supplied regex
  if (/^\/agent-store\/[^/]+\/chat/.test(pathname) && sessionParam === sessionId) return true

  return false
}
